import { jsx } from 'react/jsx-runtime';
import { t as themeStyles, T as ThemeProvider } from './ThemeProvider-BIeaAmWx-B782UArj.js';
import { createContext, useState, useMemo, useContext } from 'react';
import { c as cx } from './index-tZvMCc77.js';
import { u as useBreakpoint } from './useBreakpoint-7QkBkSeP-CfR8YWax.js';
import { a as useTranslations, L as LocalizationContext } from './LocalizationContext-UsmB5mnR-BUIYgNp2.js';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

const HammerProviderContext = createContext(
  {}
);
const TooltipLegacyGroupContext = createContext(null);
const useTooltipLegacyGroup = () => {
  const context = useContext(TooltipLegacyGroupContext);
  if (context == null) {
    throw new Error(
      "Tooltip components must be wrapped in <HammerProvider /> or <TooltipGroupContext.Provider />"
    );
  }
  return context;
};
const HammerProvider = (props) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  const { themeData, localizationData, children, className, style, ...rest } = componentProps;
  const {
    locale = "en",
    dir = "ltr",
    translations = {}
  } = localizationData ?? {};
  const classNameCombined = cx(className, [themeStyles["theme-core"]], {
    [themeStyles["mode-dark"]]: themeData?.mode === "dark",
    [themeStyles["mode-light"]]: themeData?.mode === "light"
  });
  const styleCombined = {
    ...style,
    ...layoutStyles
  };
  const breakpoint = useBreakpoint();
  const [disableDelayGroup, setDisableDelayGroup] = useState(false);
  const { translations: t } = useTranslations(translations);
  const localizationContextValue = useMemo(() => ({ locale, t }), [locale, t]);
  const tooltipLegacyGroupContextValue = useMemo(
    () => ({ disableDelayGroup: setDisableDelayGroup }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disableDelayGroup]
  );
  return /* @__PURE__ */ jsx(HammerProviderContext.Provider, { value: { breakpoint }, children: /* @__PURE__ */ jsx(
    ThemeProvider,
    {
      className: classNameCombined,
      style: styleCombined,
      theme: themeData?.theme,
      mode: themeData?.mode,
      dir,
      ...rest,
      children: /* @__PURE__ */ jsx(
        TooltipLegacyGroupContext.Provider,
        {
          value: tooltipLegacyGroupContextValue,
          children: /* @__PURE__ */ jsx(LocalizationContext.Provider, { value: localizationContextValue, children })
        }
      )
    }
  ) });
};

export { HammerProviderContext as H, HammerProvider as a, useTooltipLegacyGroup as u };
//# sourceMappingURL=HammerProvider-BEJW4XcH-DqSojvnV.js.map
